<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="maheading_2">
                                <h5 class="modal-title">Renew Licenses</h5>
                          </div>  
                           <form>
                                 <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                          <div class="col-6">
                                            <span><label class="form-label">Unit Type</label></span>
                                            <span><label id="popover-reactive-1" class="help-txt">?</label></span>
                                          </div>
                                          <div class="col-2">
                                            <label class="form-label text-center" style="width: 100%;">Quantity</label>
                                          </div>
                                          <div class="col-4">
                                            <label class="form-label text-center" style="width: 100%;">Price</label>
                                          </div>
                                        </div>
                                        <div class="row row_data_border" v-for="(pitem, sindex) in subscriptions" :key="sindex">
                                          <div class="col-6">
                                            <label :for="'subscription_plan_' + sindex">{{ pitem.name }}(s)</label>
                                          </div>
                                          <div class="col-2" v-if="pitem.name == 'Seat'">
                                            <b-form-select class="col-12 ma-input-field" v-model="unit" name="unit" :options="seat_qty_options" placeholder="Qty" v-validate="'required'" disabled="true">           
                                            </b-form-select>
                                          </div>
                                          <div class="col-2" v-else>
                                            <b-form-select class="col-12 ma-input-field" v-model="unit" name="unit" :options="qty_options" placeholder="Qty" v-validate="'required'" disabled="true" 
                                            >           
                                            </b-form-select>
                                          </div>

                                        <div class="col-4" >
                                            <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/{{ pitem.duration }}</label>
                                        </div>

                                        <div v-if="verrors.firstByRule('unit', 'required')" class="margin-bottom-5 validate-warning-msg" style="padding-left: 15px;">Quantity is required</div>
                                        </div>                                        

                                        <div class="row">
                                          <div class="col-3 col-sm-3" style="padding-top: 5px;">
                                            &nbsp;
                                           </div>
                                          <div class="col-3 col-sm-3" style="padding-top: 5px;">
                                           &nbsp;
                                          </div>
                                          <div class="col-3 col-sm-3"></div>
                                          <div class="col-3 col-sm-3" style="text-align: right; padding-right: 45px;">
                                            <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                                              Total: <span class="total_price">${{ subscriptionTotal }}</span>
                                            </button>
                                          </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12">
                                        <label class="form-label">Billing Information</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12">      
                                                <input
                                                    type="text"
                                                    id="bname"
                                                    class="col-12 col-sm-12 input-height-35 form-control"
                                                    ref="bname"
                                                    name="bname"
                                                    v-model="billingName"
                                                    v-validate="{ rules: { required: true, regex: billingNameRegex() } }"
                                                    placeholder="Billing Name"
                                                    maxlength="250"
                                                    autocomplete="off"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('bname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                                                <div v-if="verrors.firstByRule('bname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-12 col-sm-12">
                                                <b-form-select
                                                class="col-12 col-sm-12 input-height-35 form-control"
                                                id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                                                :options="country_options"
                                                v-on:change="getStateLists(billingCountry)"
                                                :disabled="(isAccessPlan) ? false: true">
                                                </b-form-select>
                                                <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                                            </div>
                                            <div class="col-12 col-sm-12 mt-2">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 input-height-35 form-control" 
                                                    name="billing_address_1" 
                                                    placeholder="Billing Address 1" 
                                                    v-model="billingAddress" 
                                                    v-validate="'required'"
                                                    maxlength="250"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                                            </div>                 
                                            <div class="col-12 col-sm-12 mt-2">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 input-height-35 form-control" 
                                                    name="billing_address_2" 
                                                    placeholder="Billing Address 2" 
                                                    v-model="billingAddress2"
                                                    maxlength="250" 
                                                    >
                                                
                                            </div>                                                       
                                            <div class="col-12 col-sm-12 mt-2">
                                                <input 
                                                type="text" 
                                                name="phone number" 
                                                id="phone_number"
                                                ref="phone_number"
                                                v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                                v-model="billingPhone"
                                                @keyup="billingPhoneValid"
                                                @blur="billingPhoneValid"
                                                class="col-12 col-sm-12 input-height-35 form-control" 
                                                placeholder="Phone Number"
                                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-4 col-sm-4">
                                                <input 
                                                    type="text" 
                                                    class="col-12 col-sm-12 input-height-35 form-control" 
                                                    name="billing_city" 
                                                    placeholder="City" 
                                                    v-model="billingCity" 
                                                    v-validate="'required'"
                                                    maxlength="150"
                                                    :disabled="(isAccessPlan) ? false: true">
                                                <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                                            </div>
                                            <div class="col-4 col-sm-4">
                                                <b-form-select
                                                class="col-12 col-sm-12 input-height-35 form-control"
                                                name="billing_state" v-model="billingState" v-validate="'required'"
                                                :options="state_options"
                                                :disabled="(isAccessPlan) ? false: true">
                                                </b-form-select>    
                                                <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                                            </div>
                                            <div class="col-4 col-sm-4">
                                                <input 
                                                type="text" 
                                                name="zip code" 
                                                id="org_zip"
                                                ref="org_zip"
                                                v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                                                v-model="billingZip"
                                                maxlength="10"
                                                class="col-12 col-sm-12 input-height-35 form-control" 
                                                placeholder="Zip"
                                                :disabled="(isAccessPlan) ? false: true">
                                                <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2" v-if="isCCRequired">
                                    <div class="col-12">
                                        <label class="form-label">Credit/Debit Card Information</label>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-12">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-12">
                                                        <input 
                                                            type="text" 
                                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                                            name="card_no" 
                                                            v-model="cardNumber" 
                                                            v-validate=" isCCRequired ? 'required|numeric' : '' "
                                                            placeholder="Credit Card #">
                                                        <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                                        <div v-if="verrors.firstByRule('card_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Card Number must contain numeric characters only</div>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-sm-12 col-md-12">
                                                        <input 
                                                            type="text" 
                                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                                            name="name_on_card" 
                                                            v-model="nameOnCard" 
                                                            v-validate=" isCCRequired ? 'required' : '' "
                                                            placeholder="Name on Card">
                                                        <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                                    </div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-4 col-sm-4">
                                                        <select 
                                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                                            name="exp_month" 
                                                            v-model="expMonth" 
                                                            v-validate=" isCCRequired ? 'required' : '' ">
                                                            <option value="">Month</option>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                                                    </div>
                                                    <div class="col-4 col-sm-4">
                                                        <b-form-select
                                                            class="col-12 col-sm-12 input-height-35 form-control"
                                                            name="exp_year" 
                                                            v-model="expYear" 
                                                            v-validate=" isCCRequired ? 'required' : '' "
                                                            :options="year_options">
                                                        </b-form-select>
                                                        <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                                                    </div>
                                                    <div class="col-4 col-sm-4">
                        <input 
                            type="password" 
                            class="col-12 col-sm-12 input-height-35 form-control" 
                            name="cvv" 
                            placeholder="CVV"
                            v-model="cvvValue" 
                            maxlength="4"
                            v-validate=" isCCRequired ? 'required' : '' "
                            role="presentation"
                            autoComplete="new-password"
                            >
                                                        <div v-if="verrors.firstByRule('cvv', 'required')" class="margin-bottom-5 validate-warning-msg">CVV is required</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center m-4">
                                    <button :disabled="process_payment_disable" type="button" class="btn btn-sm btn-blue saveBtn text-center" @click="onSubmit">
                                        Process Payment
                                    </button>
                                </div>
                                <div style="height: 20px;"></div>
                            </form>
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <AddNewAccountLicenseSuccessModal 
            :isAddNewAccountLicenseSuccessModalVisible="isAddNewAccountLicenseSuccessModalVisible"
            :accountId="accountId"
            :invoice_filename="invoice_filename"
            :total="total"
            :cc4_digit="cc4_digit"
            :type="type"
            ref="active_account_order"
            @close="close"
        />

        <AddNewAccountLicenseFailedModal
            :isAddNewAccountLicenseFailedModalVisible="isAddNewAccountLicenseFailedModalVisible"
            :type="type"
            landingPage="locations"
            @close="close"
        />

        <CreateInvoiceConfirmModal
            :isCreateInvoiceModalVisible="isCreateInvoiceModalVisible"
            landingPage="managelicense"            
            @close="close"
        />
        
    <b-popover
      target="popover-reactive-1"
      triggers="click"
      :show.sync="popoverShow"
      placement="right"
      container="my-container"
      ref="popover"
     >
      <template #title>
        <b-button @click="onClose" class="close" aria-label="Close">
          <span class="d-inline-block" aria-hidden="true">&times;</span>
        </b-button>
        <label>Mentor Mentee Unit Types</label>
      </template>

      <div>
        <div class="license-term-label"> Licenses Terms: </div>
        <div class="license-term-content"> This is where we will show licensing terms. </div>
        <div class="license-term-label"> License Pricing: </div>
        <div class="license-term-content" v-if="licenseDetails.length > 0"> Mentee licenses start at ${{licenseDetails[0].priceFormatted}}</div>
        <div style="margin-top: 20px;">
        <div class="license-term-content"> Purchasing more than one license? </div>
        <div class="license-term-content"> Purchasing 2-10 licenses? </div>
        </div>
        <div style="margin-bottom: 30px;">
        <div class="license-term-label"> Additional Info: </div>
        <div class="license-term-content" v-if="licenseDetails.length > 0"> Licenses have an expiration of {{licenseDetails[0].validityDuration}} months. </div>
        <div class="license-term-content" v-if=" licenseDetails.length > 0 && licenseDetails[0].noOfReassigns > 0"> Licenses can be reassigned {{licenseDetails[0].noOfReassigns}} time. </div>
        </div>
      </div>
    </b-popover>
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)

import AddNewAccountLicenseSuccessModal from './add_new_account_license_success_modal.vue';
import AddNewAccountLicenseFailedModal from './add_new_account_license_failed_modal.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible', 'totalLicense'],
    data() {
        return {
            loading: false,
            type: '',
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            newAccountId: '',
            invoice_filename: '',
            close_url: '',
            country_options: [],
            state_options: [],
            isAddLicenseSuccessModalVisible: false,
            isCCRequired: 1,
            paymentMethod: 'credit_card',
            isAddLicenseFailedModalVisible: false,
            isCreateInvoiceModalVisible: false,
            unit: 1,
            activeLicense: 0,
            popoverShow: false,
            licenseDetails: [],
            qty_options: [
              { value: '', text: 'Select' },
              { value: 1, text: 1 },
              { value: 2, text: 2 },
              { value: 3, text: 3 },
              { value: 4, text: 4 },
              { value: 5, text: 5 },
              { value: 6, text: 6 },
              { value: 7, text: 7 },
              { value: 8, text: 8 },
              { value: 9, text: 9 },
              { value: 10, text: 10 },
              { value: 11, text: 11 },
              { value: 12, text: 12 },
              { value: 13, text: 13 },
              { value: 14, text: 14 },
              { value: 15, text: 15 },
              { value: 16, text: 16 },
              { value: 17, text: 17 },
              { value: 18, text: 18 },
              { value: 19, text: 19 },
              { value: 20, text: 20 },
            ],
            seat_qty_options: [
              { value: '', text: 'Select' },
              { value: 5, text: 5 },
              { value: 10, text: 10 },
              { value: 15, text: 15 },
              { value: 20, text: 20 },
            ],
            licenseType: '',
            process_payment_disable: false,
            description: '',
            unitType: '',
            accountId: '',
            isAddNewAccountLicenseSuccessModalVisible: false,
            isAddNewAccountLicenseFailedModalVisible: false,
        }
    },
    components: {
        AddNewAccountLicenseSuccessModal,
        AddNewAccountLicenseFailedModal,
    },
    methods: {       
        close() {
            this.verrors.clear();
            this.$parent.isRenewLicenseModalVisible = false;
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
       setSubscriptionTotal(item) {
            this.subscriptionId = item.id;
            this.subscriptionTotal = item.price;
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (this.verrors.items.length === 0 && this.paymentMethod == 'credit_card') {
                    this.processPayment();
                }
                if (this.verrors.items.length === 0 && this.paymentMethod == 'check') { 
                    //this.$parent.isAddLicenseModalVisible = false;
                    this.isCreateInvoiceModalVisible = true;
                }
                
            });
        },
        getPriceforSubscription: function() {
          axios('/getsubscriptionPrice',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
                accountId: this.accountId,
              }
            }
          )
          .then(response => {
              this.subscriptions[0].price = response.data;
              if(this.unitType == 'Seat') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else {
                this.subscriptionTotal = this.subscriptions[0].price * this.unit;
              }
              this.subscriptionPrice = response.data;
          })
          .catch(error => {

          });
        },
        processPayment() {
            this.process_payment_disable = true;
            this.loading = true;
            axios('/renew-orders', 
            {
                method: 'POST',
                data: {
                        "subscription_id": this.subscriptionId,
                        "subscription_price": this.subscriptionPrice,
                        "units": this.unit,
                        "description": this.description,
                        "subscription_total": this.subscriptionTotal,
                        "account_id": this.accountId,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": this.paymentMethod,
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                },
            })
            .then((response) => {
                this.process_payment_disable = false;
                this.loading = false;
                this.verrors.clear();
                this.invoice_filename = response.data.invoice_filename;
                if (response.data.order_msg != 'failed') {
                    this.$refs.active_account_order.invoice_filename = response.data.invoice_filename;
                    this.isAddNewAccountLicenseSuccessModalVisible = true;
                    this.$refs.active_account_order.total = response.data.total;
                    this.$refs.active_account_order.cc4_digit = response.data.ccNumber4digit;
                } else {
                    this.isAddNewAccountLicenseFailedModalVisible = true;
                }
            })
            .catch(error => {
                this.process_payment_disable = false;
                console.log(error)
            });
        },
        getSubscriptionLists() {
            axios.get('/renew-active-subscriptions/' + this.accountId + '/Single')
            .then((resp) => {
                this.loading = false;
                this.subscriptions = resp.data;
                this.unitType = this.subscriptions[0].name;
                this.licenseType = this.subscriptions[0].licenseType;
                this.unit = this.subscriptions[0].minQty;
                this.description = this.subscriptions[0].description;
                if((this.unit > 1) && this.subscriptions[0].name != 'Seat') {
                    this.qty_options = [];
                    var qty =  { value: '', text: 'Select' };
                    this.qty_options.push(qty);
                    for(var i=this.unit; i < 21; i++) {
                        var qty = {value: i, text: i};
                        this.qty_options.push(qty);
                    }
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else if(this.subscriptions[0].name == 'Seat') {
                    this.subscriptionTotal = this.subscriptions[0].price;
                }
                else {
                    this.subscriptionTotal = this.subscriptions[0].price * this.unit;
                }
                this.subscriptionId = this.subscriptions[0].id;
                this.subscriptionPrice = this.subscriptions[0].price;
                this.getLicenseTermDetails();
            })
            .catch(error => {

            });
        },
        getLicenseTermDetails() {
            axios.get('/desktop/get-license-term-details/' + this.subscriptionId)
            .then((resp) => {              
                this.licenseDetails = resp.data;                            
            })
            .catch(error => {

            });
        },
        loadInitialData(accountId) {
            this.accountId = accountId;
            this.verrors.clear();
            this.getCountryLists();
            this.getStateLists('US');
            this.getSubscriptionLists();
            this.getExpiryYears();
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No Renew Subscription';
                }
            }
        },
        hide() { 
            this.$parent.isRenewLicenseModalVisible = false;
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'managelicense'});              
                window.open(routeData.href, '_self');                
            }
        },
        choosePaymentMode(event) {
            if(event.target.value == 'credit_card') {
                this.isCCRequired = 1;
            }
            else {
                this.isCCRequired = 0;                
            }
        },
        onClose() {
          this.popoverShow = false
        },
    },
    created() {
      axios('/desktop/get-account-active-license/'+ this.accountId,
      {
        method: 'GET'        
      })
      .then(resp => {        
        this.activeLicense = resp.data[0].active_license;
      })
      .catch(() => {
      });      
    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 20px;
  font-weight: 900;
  width: auto;
  padding: 5px 20px;
  font-size: 18px;
}
.totalBtn, .totalBtn.btn-blue {
  color: #707070; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 8px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 32px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; margin-top: 10px; font-size: 14px;border-bottom: 2px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.total_price { color: #00acee; }
.custom-select { height: 34px; }
.license-term-content { font-size: 12px;}
.license-term-label { color: #00ACEE; font-weight: bold; font-size: 13px; padding-top: 10px;}
.help-txt {
    display: inline-block;
    height: 15px;
    width: 15px;
    line-height: 15px;
    -moz-border-radius: 8px;
    border-radius:8px;
    border: 1px solid #00ACEE;
    background-color: white;
    color: #00ACEE;
    text-align: center;
    font-size: 0.75em;
    cursor: pointer;
}
.btn-secondary:hover { background-color: #FFF !important;}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
</style>
<style>
.popover-body { padding-right: 50px !important;}
.popover-header div { text-align: center;}
button.close { font-size: 30px;margin-top: -7px;}
.popover .popover-header { font-size: 14px; font-weight: bold;}
.popover { width: 340px !important; max-width: 340px !important;}
.bs-popover-right > .arrow::before {
    border-right-color: rgba(0, 172, 238, 0.90) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/renew_license.vue